export const QUERY_CACHE_TIME = 30 * 60 * 1000 // 30 min

export const DEBOUNCE_DELAY = 500
